 
document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.image-accordion-section .accordion-header');

  accordions.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      const isOpen = item.classList.contains('active');

      document
        .querySelectorAll('.image-accordion-section .accordion-item')
        .forEach(i => {
          i.classList.remove('active');
          i.querySelector('.accordion-icon').textContent = '+';
        });

      if (!isOpen) {
        item.classList.add('active');
        item.querySelector('.accordion-icon').textContent = '−';
      }
    });
  });

 
  const cards = document.querySelectorAll(".video-wrapper");

  cards.forEach((card) => {
    const video = card.querySelector("video");
    const btn = card.querySelector(".play-btn");

    function pauseAllVideos() {
      document.querySelectorAll(".video-wrapper video").forEach(v => {
        if (v !== video) {
          v.pause();
          v.parentElement.querySelector(".play-btn").style.display = "block";
        }
      });
    }

    // Click on button
    btn.addEventListener("click", function () {
      if (video.paused) {
        pauseAllVideos();
        video.play();
        btn.style.display = "none";
      } else {
        video.pause();
        btn.style.display = "block";
      }
    });

    // Click on video itself (same behavior)
    video.addEventListener("click", function () {
      if (video.paused) {
        pauseAllVideos();
        video.play();
        btn.style.display = "none";
      } else {
        video.pause();
        btn.style.display = "block";
      }
    });

    // When video ends → show play button again
    video.addEventListener("ended", function () {
      btn.style.display = "block";
    });
  });
 
});
 
